import React, { useState } from "react";
import "../Styles/Footer.css";

import footercbn from "../essets/footercbn.png";
import footerlogo from "../essets/footerlogo.png";

// PDF documents
import privacyPolicyPdf from "../essets/App Privacy Policy.pdf";

// IMPORTANT:
// Replace this with your actual Terms & Conditions PDF if you have
// a separate PDF file.
//
// Example:
// import termsConditionsPdf from "../essets/Terms and Conditions.pdf";

import termsConditionsPdf from "../essets/App Privacy Policy.pdf";

import { FaSquareFacebook, FaSquareTwitter } from "react-icons/fa6";
import { FaInstagramSquare } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";

const Footer = () => {
  // Only used for Delete Account popup
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // =========================================
  // OPEN DELETE ACCOUNT POPUP
  // =========================================
  const openDeleteModal = () => {
    setShowDeleteModal(true);
    setEmail("");
    setMessage("");
    setMessageType("");
  };

  // =========================================
  // CLOSE DELETE ACCOUNT POPUP
  // =========================================
  const closeDeleteModal = () => {
    if (loading) return;

    setShowDeleteModal(false);
    setEmail("");
    setMessage("");
    setMessageType("");
  };

  // =========================================
  // DELETE ACCOUNT REQUEST
  // =========================================
  const handleDeleteAccount = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim();

    // Required validation
    if (!trimmedEmail) {
      setMessage("Please enter your email address.");
      setMessageType("error");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedEmail)) {
      setMessage("Please enter a valid email address.");
      setMessageType("error");
      return;
    }

    try {
      setLoading(true);
      setMessage("");
      setMessageType("");

      /*
       * =========================================
       * DELETE ACCOUNT API
       * =========================================
       *
       * Replace this URL with your real backend
       * delete-account-request API endpoint.
       *
       * Example:
       * https://yourdomain.com/api/account/delete-request
       *
       * If your project already has an API service,
       * you can call that API here instead.
       */

      const response = await fetch("/api/account/delete-request", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: trimmedEmail,
        }),
      });

      let data = {};

      try {
        data = await response.json();
      } catch (jsonError) {
        data = {};
      }

      if (!response.ok) {
        throw new Error(
          data?.message ||
            data?.detail ||
            "Unable to submit your deletion request."
        );
      }

      // Success
      setMessage(
        data?.message ||
          "Your account deletion request has been submitted successfully."
      );

      setMessageType("success");

      setEmail("");

      // Close popup after 2.5 seconds
      setTimeout(() => {
        setShowDeleteModal(false);
        setMessage("");
        setMessageType("");
      }, 2500);
    } catch (error) {
      console.error("Delete account request error:", error);

      setMessage(
        error?.message ||
          "Something went wrong. Please try again later."
      );

      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* =========================================
          FOOTER
      ========================================== */}

      <footer className="main-cont">

        {/* =========================================
            TOP FOOTER
        ========================================== */}

        <div className="footer-top">

          {/* Left Side */}
          <div className="footer-left">

            <img
              className="cbnpic"
              src={footercbn}
              alt="Footer"
            />

            <img
              className="foot-logo"
              src={footerlogo}
              alt="Footer Logo"
            />

          </div>

          {/* Social Icons */}
          <div className="footer-icons">

            <a
              href="https://www.facebook.com/iNRKandukuru/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaSquareFacebook className="f-icon" />
            </a>

            <a
              href="https://x.com/inrKandukuru?lang=en"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X / Twitter"
            >
              <FaSquareTwitter className="f-icon" />
            </a>

            <a
              href="https://www.instagram.com/inturi_nageswararao/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagramSquare className="f-icon" />
            </a>

            <a
              href="https://www.youtube.com/@INTURINAGESWARARAO"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <IoLogoYoutube className="f-icon" />
            </a>

          </div>
        </div>

        {/* =========================================
            DIVIDER
        ========================================== */}

        <div className="footer-divider"></div>

        {/* =========================================
            BOTTOM FOOTER
        ========================================== */}

        <div className="footer-bottom">

          {/* Copyright */}
          <p className="copyright-text">
            © 2026 NHRC. All Rights Reserved.
          </p>

          {/* =========================================
              LEGAL LINKS
          ========================================== */}

          <div className="footer-legal-links">

            {/* PRIVACY POLICY
                Opens PDF in a new browser tab */}
            <a
              href={privacyPolicyPdf}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-link"
            >
              Privacy Policy
            </a>

            <span className="footer-legal-divider">|</span>

            {/* TERMS & CONDITIONS
                Opens PDF in a new browser tab */}
            <a
              href={termsConditionsPdf}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-link"
            >
              Terms &amp; Conditions
            </a>

            <span className="footer-legal-divider">|</span>

            {/* DELETE ACCOUNT
                Opens ONLY the popup */}
            <button
              type="button"
              className="footer-legal-link footer-button delete-footer-link"
              onClick={openDeleteModal}
            >
              Delete Your Account
            </button>

          </div>

          {/* Developer */}
          <p className="developer-text">
            Designed &amp; Developed by{" "}
            <strong>YSK Info Tech Pvt. Ltd.</strong>
          </p>

        </div>
      </footer>

      {/* =========================================
          DELETE ACCOUNT POPUP
      ========================================== */}

      {showDeleteModal && (
        <div
          className="footer-modal-overlay"
          onMouseDown={(e) => {
            // Close only when clicking outside modal
            if (
              e.target === e.currentTarget &&
              !loading
            ) {
              closeDeleteModal();
            }
          }}
        >

          <div
            className="footer-modal delete-account-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-account-title"
          >

            {/* Close Button */}
            <button
              type="button"
              className="modal-close-btn"
              onClick={closeDeleteModal}
              disabled={loading}
              aria-label="Close"
            >
              ×
            </button>

            {/* Title */}
            <h2 id="delete-account-title">
              Delete Your Account
            </h2>

            {/* Description */}
            <p className="delete-modal-description">
              Enter the email address linked to your account. We'll
              process your deletion request from there.
            </p>

            {/* Delete Account Form */}
            <form
              className="delete-account-form"
              onSubmit={handleDeleteAccount}
            >

              {/* Email */}
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setMessage("");
                  setMessageType("");
                }}
                placeholder="Enter your email"
                autoComplete="email"
                disabled={loading}
                className="delete-email-input"
                autoFocus
              />

              {/* Message */}
              {message && (
                <p
                  className={`delete-form-message ${
                    messageType === "success"
                      ? "success"
                      : "error"
                  }`}
                >
                  {message}
                </p>
              )}

              {/* Buttons */}
              <div className="delete-modal-actions">

                {/* Cancel */}
                <button
                  type="button"
                  className="delete-cancel-btn"
                  onClick={closeDeleteModal}
                  disabled={loading}
                >
                  Cancel
                </button>

                {/* Submit */}
                <button
                  type="submit"
                  className="delete-submit-btn"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>

              </div>

            </form>

          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
